export const getPrimaryModifierKey = () => {
  if (typeof navigator === 'undefined') {
    return 'Ctrl';
  }
  const platform = (navigator.userAgent || navigator.platform || '').toLowerCase();
  const isMacLike = /mac|iphone|ipad|ipod/.test(platform);
  return isMacLike ? 'Command' : 'Ctrl';
};

export const formatShortcut = (...keys) => keys.filter(Boolean).join('+');
